
import { defineComponent, markRaw } from 'vue';
import Icon from '@ant-design/icons-vue';
import SelectArrowSvg from './svg/SelectArrowSvg.vue';

export default defineComponent({
  name: 'SelectArrowIcon',
  components: {
    Icon
  },
  data() {
    return {
      SelectArrowSvg: markRaw(SelectArrowSvg)
    };
  }
});
